import { render, staticRenderFns } from "./LnbSetting.vue?vue&type=template&id=dc67a656&"
import script from "./LnbSetting.vue?vue&type=script&lang=ts&"
export * from "./LnbSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports